import {
    useStyles,
    ReadMore,
    useAppDisplayModeContext,
    useTheme,
} from '@archipro-design/aria';
import * as S from './AboutDescription.style';
import { useState } from 'react';

import type { OverviewLoaderData } from '@modules/professional/page/OverviewPage';
import { useLoaderData } from 'react-router';
import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import { useIsDisabledInPreview } from '~/modules/root/hook/use-is-disabled-in-preview';

const MAX_LINES = {
    MOBILE: 7,
    DESKTOP: 15,
};

export const AboutDescription: React.FC = () => {
    const { css } = useStyles();
    const { mobile: isMobile } = useAppDisplayModeContext();
    const { professionalOverview } = useLoaderData<OverviewLoaderData>();
    const theme = useTheme();
    const content = professionalOverview?.BlockSummary;
    const preventOpenLink = useIsDisabledInPreview('profile_social_links');
    const [refreshKey, setRefreshKey] = useState(0);
    const [isExpanded, setIsExpanded] = useState(false);
    const clickProxy = useWebsiteTrackingProxy(
        {
            professionalID: professionalOverview.ID,
            professionalTitle: professionalOverview.Title,
            itemType: 'Professional',
        },
        { preventOpenLink },
    );

    if (!content) {
        return null;
    }

    return (
        <div className={css(S.aboutDescWrapper)}>
            <ReadMore
                maxLines={isMobile ? MAX_LINES.MOBILE : MAX_LINES.DESKTOP}
                content={
                    <span
                        key={`profile-tab-${refreshKey}`}
                        dangerouslySetInnerHTML={{ __html: content }}
                        onClick={clickProxy}
                        onContextMenu={clickProxy}
                    />
                }
                readMoreText="Read more"
                variables={{
                    contentLineHeight: isMobile
                        ? 1.5
                        : theme.siteVariables.lineHeightSmall,
                }}
                className={css(
                    S.ReadMoreText,
                    isExpanded ? S.hideToggleButton : {},
                )}
                toggleButton={{
                    onClick: () => {
                        setIsExpanded(true);
                        setRefreshKey((prev) => prev + 1);
                    },
                }}
            />
            <div className={css(S.readMoreDivider)}></div>
        </div>
    );
};
